// queries/useGenerateAPIKey.ts
"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { POST_GENERATE_API_KEY } from "api";
import { useToast } from "@chakra-ui/react";

export const useGenerateAPIKey = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await fetch(POST_GENERATE_API_KEY, {
        method: "POST",
      });

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["useAPIKey"] });
      console.log("Generated API Key successfully");

      toast({
        title: "Success",
        description: "Generated API Key successfully",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      console.error("Error generating API Key:", error);
    },
  });
};

export default useGenerateAPIKey;
